const pro = {
  path: 'https://api.growup.link'
}
module.exports = pro



// WEBPACK FOOTER //
// ./src/config/pro.js